/**
 * @generated SignedSource<<55d04aa7d657ed030b320504c1037831>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersMassageToNewsletterItemNewsletter$data = {
  readonly alternativeName: string;
  readonly description: {
    readonly text: string | null;
  } | null;
  readonly entityId: string;
  readonly homepageDescription: {
    readonly text: string | null;
  } | null;
  readonly name: string;
  readonly summary: {
    readonly text: string | null;
  } | null;
  readonly " $fragmentType": "helpersMassageToNewsletterItemNewsletter";
};
export type helpersMassageToNewsletterItemNewsletter$key = {
  readonly " $data"?: helpersMassageToNewsletterItemNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersMassageToNewsletterItemNewsletter"
};

(node as any).hash = "e8a697054db5767779c5e7074164d5c5";

export default node;
